import {makeStyles} from '@material-ui/core';
import {useLocalStorage} from '@rehooks/local-storage';
import {LocalStorageKeys} from 'common/types';
import React from 'react';
import {useLocation} from 'react-router-dom';
import {rieltor} from 'styles/theme';
import {useUserSettings} from '../../store/userSettings/reducer';

interface BadgeProps {
  value: string | number;
  url: string;
}

type BadgeStorage = Record<string, boolean>;

const useBadgeDismissStyles = makeStyles(() => ({
  badge: {
    borderRadius: '12px',
    fontFamily: rieltor.fontFamily,
    backgroundColor: rieltor.purple,
    padding: '0 8px',
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: '20px',
    color: '#fff',

    '&.new': {
      fontSize: '12px',
      backgroundColor: rieltor.yellow,
      color: '#000',
    },
  },
}));

// Backend decide where NEW label appears (UserMeta class), and update DB if route visited.
// LocalStorage sync with backend values for smooth updates
export const BadgeDismiss = ({value, url}: BadgeProps) => {
  const classes = useBadgeDismissStyles();
  const location = useLocation();
  const userSettings = useUserSettings();

  const labelInitStatus = userSettings.labelNew;
  const badgesStorage = useLocalStorage<BadgeStorage>(LocalStorageKeys.BadgesDismiss, labelInitStatus);

  if (!labelInitStatus.hasOwnProperty(url)) {
    return null;
  }

  let badges = badgesStorage[0];
  const setBadges = badgesStorage[1];
  if (badges === null) {
    badges = labelInitStatus;
  }

  if (badges.hasOwnProperty(url) && badges[url] === false) {
    return null;
  }

  if (location.pathname.substring(1) === url) {
    badges[url] = false;
    setBadges(badges);
  }

  if (value === undefined) {
    return null;
  }

  return (
    <div className={`${classes.badge} new`}>{value}</div>
  );
};
